import { QuotationType } from "redux/slices/quotation";
import DateRangePickerRedux from "components/molecules/DateRangePickerRedux";
import InputRedux from "components/molecules/InputRedux";
import PhoneInputRedux from "components/molecules/PhoneInputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import { digits, pageSize } from "utils/normalize.util";
import { dateRangeFilter, email, phone } from "utils/validate.util";
import PageSize from "components/organisms/PageSize";
import SelectPartner from "components/organisms/SelectPartner";
import SelectCompany from "components/organisms/SelectCompany";
import SelectDriver from "components/organisms/SelectDriver";
import SelectOnAll from "./SelectOnAll";

export { default } from "./QuotationFilters";

export interface QuotationFiltersProps {
	type: QuotationType;
	query:any;
	handleResetquery:()=>void
}

export const fields: ReduxFormField[] = [
	{
		name: "company_name",
		label: "Name",
		component: InputRedux,
		cellProps: { sm: 4, lg: 3 },
	},
	
	{
		name: "company_email",
		label: "Email",
		validate: [email],
		component: InputRedux,
		cellProps: { sm: 4, lg: 3 },
		InputProps: { type: "email" },
	},
	// {
	// 	name: "phone",
	// 	label: "Phone",
	// 	validate: [phone],
	// 	component: PhoneInputRedux,
	// 	cellProps: { sm: 6, lg: 3 },
	// },
	
	// {
	// 	name: "date",
	// 	label: "Date",
	// 	validate: [dateRangeFilter],
	// 	component: DateRangePickerRedux,
	// 	cellProps: { md: 6 },
	// 	DateRangePickerProps: {
	// 		onChange: () => {},
	// 		InputFieldProps: {},
	// 		value: { date: ["", ""], error: ["", ""] },
	// 	},
	// },
	{
		name: "quotation_id",
		label: "Id",
		normalize: digits,
		component: InputRedux,
		cellProps: { sm: 6, md: 3 },
	},
	{
		name: "page_size",
		label: "Page Size",
		normalize: pageSize,
		component: PageSize,
		cellProps: { sm: 6, md: 3 },
		PageSizeProps: { form: "QuotationFiltersForm" },
	},
];
